import './partners-list.style.scss'
import 'slick-carousel/slick/slick.css'

import React from 'react'

import { CrossIcon, PartnersListMode, TickIcon, WithSlider } from './partners-list.utils'

export type PartnerItem = {
    name: string;
    callToActionUrl: string;
    maxRequestedAmount: string;
    terms: string;
    guarantee: boolean;
    operation: string;
    nature: string;
    dataCategory: string;
    dataLabel: string;
    dataAction: string;
    logo:() => JSX.Element;
}

type PartnersListProps = {
    showArrows?: boolean,
    partners: PartnerItem[],
    mode: PartnersListMode,
    header?:() => JSX.Element,
}

const PartnersList: React.FC<PartnersListProps> = ({ showArrows = true, partners, mode, header: Header }): JSX.Element => {

    const Items = partners.map((partner: PartnerItem, key: number) => (
        <div className="item" key={key}>
            <div>
                { partner.logo() }
            </div>

            <div>
                <label>valor limite</label>
                <span>{ partner.maxRequestedAmount }</span>
            </div>

            <div>
                <label>prazo até</label>
                <span>{ partner.terms }</span>
            </div>

            <div className="guarantee">
                <label>garantia?</label>
                <span className="text">
                    { partner.guarantee ? 'sim' : 'não' }
                </span>
                <span className="icon">
                    { partner.guarantee && <TickIcon /> }
                    { !partner.guarantee && <CrossIcon /> }
                </span>
            </div>

            <div>
                <label>operação</label>
                <span>{ partner.operation }</span>
            </div>

            <div>
                <label>pessoa</label>
                <span>{ partner.nature }</span>
            </div>

            <div>
                <a
                    className="btn-biz primary partner-click-action"
                    href={partner.callToActionUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-category={partner.dataCategory}
                    data-label={partner.dataLabel}
                    data-action={partner.dataAction}
                >
                    ver
                </a>
            </div>
        </div>
    ));

    if (mode === PartnersListMode.COLUNM) {
        return (
            <div className="partners-list-container">
                <Header />

                <WithSlider showArrows={showArrows} size={partners.length}>
                    { Items }
                </WithSlider>
            </div>
        )
    }

    return (
        <div className="partners-list-container line">
            <Header />

            <div className="partners-list-in-line">
                <div className="desktop">
                    { Items }
                </div>

                <div className="mobile">
                    <WithSlider showArrows={showArrows} size={partners.length}>
                        { Items }
                    </WithSlider>
                </div>
            </div>
        </div>
    );
}

export default PartnersList;
